<template>
  <div>
    <b-row>
      <b-col>
        <span class="booking-details-title d-block rounded mb-2">
          <h4 class="mb-0">TAXA SERVICU</h4>
          <hr class="my-1" style="border-color:white;">
          <p class="mb-0">Aici poti adauga comisionul agentiei pentru a putea transmite clientului tau oferta in format PDF direct din sistemul nostru de Rezervari. Simplu si rapid!</p>
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <table class="table table-sm text-center">
          <thead class="t-head thead-light text-center">
            <tr>
              <td>Nr. stele</td>
              <td>Comision/camera/sejur Fix</td>
              <td>Comision/camera/sejur (%)Procentual</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stars in order" :key="'fee' + stars">
              <td>
                {{ stars ? (stars + '*') : 'Fara clasificare'}}
              </td>
              <td>
                <b-form-group class="mb-0">
                <b-input
                  type="number"
                  v-model="fees[stars].value"
                  size="sm" />
                </b-form-group>
              </td>
              <td>
                <b-form-group class="mb-0">
                <b-input
                  type="number"
                  v-model="fees[stars].percent"
                  size="sm" />
                </b-form-group>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'HotelFeesEdit',
  props: ['fees'],
  data () {
    return {
      order: [5, 4, 3, 2, 1, 0]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
